const UPDATE_APPLIED_FILTER = 'desempeno/filtros/UPDATE_APPLIED_FILTER';

export { UPDATE_APPLIED_FILTER };
